import {
  Accordion,
  DatePicker,
  Icon,
  InputItem,
  List,
  NavBar,
  Picker,
  TextareaItem,
} from "antd-mobile";
import React, { useCallback, useEffect, useState } from "react";
import instance from "../../../util/axios";
import { getQueryString } from "../../../util/getQueryString";
import "./index.css";
import { DictionaryOption } from "./schema";

const id: string = getQueryString("id");
const orderType = [
  {
    value: "fef2a687f35c2936843e3ed03dfbc567",
    label: "新增",
  },
  {
    value: "fef2a687f35c2936843e3ed03dfbc568",
    label: "续费",
  },
];

const customerCategory = [
  {
    value: "78393aa0f9f646188766c864dd6499d0",
    label: "个人客户",
  },
  {
    value: "a70278f476b247ad8ab8e922a9e48c20",
    label: "企业客户",
  },
];

export default function ZhengBaoOrderEcho() {
  const [masterData, setMasterData] = useState<any>();
  const [detailData, setDetailData] = useState<any[]>([]);
  const [productInfo, setProductInfo] = useState<any[]>([]);
  const [trainingproductInfo, setTrainingProductInfo] = useState<any[]>([]);
  const [customerName, setCustomerName] = useState<
    {
      value: string;
      label: string;
    }[]
  >([]);
  const [sessionInfo, setSessionInfo] = useState<{
    userId: string;
    name: string;
  }>({ userId: "", name: "" });
  const [contactName, setContactName] = useState("");
  const [productOptions, setProductOptions] = useState<DictionaryOption[]>([]);
  const [giftOptions, setGiftOptions] = useState<DictionaryOption[]>([]);
  const [serviceDictionary, setServiceDictionary] = useState<
    DictionaryOption[]
  >([]);
  const [payDictionary, setPayDictionary] = useState<DictionaryOption[]>([]);
  const [companyDictionary, setCompanyDictionary] = useState<
    DictionaryOption[]
  >([]);
  const [staffDictionary, setStaffDictionary] = useState<DictionaryOption[]>(
    []
  );
  const [productDictionary, setProductDictionary] = useState<
    DictionaryOption[]
  >([]);
  const [costDescriptions, setCostDescriptions] = useState<any[]>([]);
  const [memberCardDetail, setMemberCardDetail] = useState<any[]>([]);
  const [serviceDetail, setServiceDetail] = useState<any[]>([]);
  const [costDetail, setCostDetail] = useState<any[]>([]);
  const [collectionTypeDetail, setCollectionTypeDetail] = useState<any[]>([]);
  const [orderSplitDetail, setOrderSplitDetail] = useState<any[]>([]);
  const [orderSplitSaleDetail, setOrderSplitSaleDetail] = useState<any[]>([]);
  const [orderSplitServiceDetail, setOrderSplitServiceDetail] = useState<any[]>(
    []
  );
  const [productNames, setProductNames] = useState<string[]>([]);
  const [currentNode, setCurrentNode] = useState<string>("");
  const [positionIds, setPositionIds] = useState("");

  const getContacts = useCallback((customerId) => {
    instance
      .post(`/wf/form/vsheet/rpc`, {
        method: "getMainContact",
        workflowTemplateId: "ec4f846a6db74ec98395554a4c726a0f",
        paramsJson: JSON.stringify({ customerId: customerId }),
      })
      .then((resp) => {
        if (resp.data.Status === "1" && resp.data.Data) {
          setContactName(resp.data.Data.name);
        }
      });
  }, []);

  useEffect(() => {
    instance.get(`/crm/user/`).then((resp) => {
      setSessionInfo(resp.data.Data);
    });
  }, []);

  useEffect(() => {
    if (sessionInfo && sessionInfo.userId) {
      instance
        .post(`/wf/form/vsheet/rpc`, {
          method: "getMyCustomerId",
          workflowTemplateId: "ec4f846a6db74ec98395554a4c726a0f",
          paramsJson: JSON.stringify({ advisorId: sessionInfo.userId }),
        })
        .then((resp) => {
          if (resp.data.Status === "1") {
            setCustomerName(
              resp.data.Data.map((item: { id: any; text: any }) => ({
                value: item.id,
                label: item.text,
              }))
            );
          }
        });

      instance
        .post(`/wf/form/vsheet/rpc`, {
          method: "getStaffIsOrNotFinance",
          workflowTemplateId: "ec4f846a6db74ec98395554a4c726a0f",
          paramsJson: JSON.stringify({ staffId: sessionInfo.userId }),
        })
        .then((resp) => {
          if (resp.data.Status === "1") {
            const positionIds = resp.data.Data[0]["positionIds"];
            setPositionIds(positionIds);
          }
        });
    }
  }, [sessionInfo]);

  useEffect(() => {
    instance
      .get(
        `/wf/formMobile/data?workflowTemplateId=ec4f846a6db74ec98395554a4c726a0f&id=${id}`
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setMasterData(resp.data.Data.data);
          setDetailData(resp.data.Data.details);
          let currentNodeTitle;
          const forms = resp.data.Data.form;
          const formsNodes = forms.nodes;
          if (
            forms.activeStep === 0 ||
            forms.status === 1 ||
            forms.status === 3
          ) {
            currentNodeTitle = "未提交";
          } else {
            currentNodeTitle = forms.activeStep
              ? formsNodes[forms.activeStep].title
              : "";
          }
          setCurrentNode(currentNodeTitle);
          setProductInfo(
            resp.data.Data.details.find(
              (item: { tableName: string }) =>
                item.tableName === "正保产品订单_产品"
            ).data
          );
          setTrainingProductInfo(
            resp.data.Data.details.find(
              (item: { tableName: string }) =>
                item.tableName === "正保产品订单_内训"
            ).data
          );
          setMemberCardDetail(
            resp.data.Data.details.find(
              (item: { tableName: string }) => item.tableName === "会员卡明细"
            ).data
          );
          setServiceDetail(
            resp.data.Data.details.find(
              (item: { tableName: string }) => item.tableName === "产品服务明细"
            ).data
          );
          setCollectionTypeDetail(
            resp.data.Data.details.find(
              (item: { tableName: string }) => item.tableName === "到款方式明细"
            ).data
          );

          const cost = resp.data.Data.details.find(
            (item: { tableName: string }) => item.tableName === "成本预算明细"
          ).data;
          if (
            (positionIds &&
              positionIds.indexOf("a781ec9654b84c73a71d91eb716fefea") !== -1) ||
            positionIds.indexOf("4df40d19935c460eb5a64e320cb767d5") !== -1
          ) {
            setCostDetail(cost);
          } else {
            setCostDetail(
              cost
                .filter(
                  (item: { data: { 预算类别: string } }) =>
                    item.data.预算类别 !== "01237019848f11e7832f006617543a41"
                )
                .filter(
                  (item: { data: { 预算类别: string } }) =>
                    item.data.预算类别 !== "01234019848f11e7832f006617543a41"
                )
            );
          }
          const splitArr = resp.data.Data.details.find(
            (item: { tableName: string }) => item.tableName === "业绩拆分明细"
          ).data;
          if (splitArr.length > 0) {
            const serviceArr: any[] = [];
            const saleArr: any[] = [];
            splitArr.forEach((element: any) => {
              const data = element.data;
              if (data.服务地业务员) {
                const serviceObj = {
                  服务地业务员: data.服务地业务员,
                  比例: data.服务地业务员_比例,
                };
                serviceArr.push(serviceObj);
              }
              if (data.销售地业务员) {
                const saleObj = {
                  销售地业务员: data.销售地业务员,
                  比例: data.销售地业务员_比例,
                };
                saleArr.push(saleObj);
              }
            });
            setOrderSplitSaleDetail(saleArr);
            setOrderSplitServiceDetail(serviceArr);
          }

          setOrderSplitDetail(splitArr);

          getContacts(resp.data.Data.data.customerId);
        }
      });
  }, [getContacts, positionIds]);

  useEffect(() => {
    if (
      detailData.length > 0 &&
      detailData.find((item) => item.tableName === "正保产品订单_产品").data
        .length > 0
    ) {
      instance
        .get(`/custom/enterprise/zhengbao/order/getPsiSkuCategoryAndSku`)
        .then((resp) => {
          if (resp.data.Status === "1") {
            const data = resp.data.Data;
            const products = detailData.find(
              (item: { tableName: string }) =>
                item.tableName === "正保产品订单_产品"
            ).data;

            const options = data.filter(
              (item: { value: string }) =>
                item.value !== "5d260a7cf9a244518a7f16853c234e1a"
            );
            const productNames: string[] = [];
            products.forEach((element: any) => {
              const arrAscription = options.find(
                (item: { value: string }) =>
                  item.value === element.data.产品归属
              );
              if (arrAscription) {
                const arrCategory = arrAscription.children.find(
                  (item: { value: string }) =>
                    item.value === element.data.产品分类
                );
                if (arrCategory) {
                  const arrName = arrCategory.children.find(
                    (item: { value: string }) =>
                      item.value === element.data.产品名称
                  );
                  productNames.push(arrName.label);
                }
              }
            });
            setProductNames(productNames);
            setProductOptions(
              data.filter(
                (item: { value: string }) =>
                  item.value !== "5d260a7cf9a244518a7f16853c234e1a"
              )
            );
            setGiftOptions(
              data.filter(
                (item: { value: string }) =>
                  item.value === "5d260a7cf9a244518a7f16853c234e1a"
              )[0].children
            );
          }
        });
    }
  }, [detailData]);

  useEffect(() => {
    instance
      .get(
        `/crm/common/CommonApi/GetZLSelectDict?pageIndex=&pageSize=&dictionaryName=psi_service&key=&selectId=&filter=&colName=&isFull=true`
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setServiceDictionary(
            resp.data.Data.map((item: { uuid: any; name: any }) => ({
              value: item.uuid,
              label: item.name,
            }))
          );
        }
      });
    instance
      .get(
        `/crm/common/CommonApi/GetZLSelectDict?pageIndex=&pageSize=&dictionaryName=${encodeURI(
          "dict_正保产品订单_支付方式"
        )}
&key=&selectId=&filter=&colName=&isFull=true`
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setPayDictionary(
            resp.data.Data.map((item: { uuid: any; name: any }) => ({
              value: item.uuid,
              label: item.name,
            }))
          );
        }
      });
    instance
      .get(
        `/crm/common/CommonApi/GetZLSelectDict?pageIndex=&pageSize=&dictionaryName=${encodeURI(
          "dict_正保产品订单_到款单位"
        )}
&key=&selectId=&filter=&colName=&isFull=true`
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setCompanyDictionary(
            resp.data.Data.map((item: { uuid: any; name: any }) => ({
              value: item.uuid,
              label: item.name,
            }))
          );
        }
      });
    instance
      .get(
        `/crm/common/CommonApi/GetZLSelectDict?pageIndex=&pageSize=&dictionaryName=base_staff
&key=&selectId=&filter=&colName=&isFull=true`
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setStaffDictionary(
            resp.data.Data.map((item: { uuid: any; name: any }) => ({
              value: item.uuid,
              label: item.name,
            }))
          );
        }
      });

    instance
      .get(
        `/crm/common/CommonApi/GetZLSelectDict?pageIndex=&pageSize=&dictionaryName=v_psi_sku_inner_training
&key=&selectId=&filter=&colName=&isFull=true`
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setProductDictionary(
            resp.data.Data.map((item: { uuid: any; name: any }) => ({
              value: item.uuid,
              label: item.name,
            }))
          );
        }
      });

    instance
      .post(`/wf/form/vsheet/rpc`, {
        method: "getBudget",
        workflowTemplateId: "ec4f846a6db74ec98395554a4c726a0f",
        paramsJson: JSON.stringify({}),
      })
      .then((resp) => {
        if (resp.data.Status === "1") {
          setCostDescriptions(resp.data.Data);
        }
      });
  }, []);

  return (
    <div className="echoPageWrapper orderWrapper">
      <NavBar
        className="orderNavBar"
        icon={
          <Icon
            type="left"
            onClick={() => {
              window.location.href = "/colseWebView";
            }}
          />
        }>
        销售及内训订单
      </NavBar>
      <div className="mt45"></div>
      <List className="picker-list">
        <InputItem editable={false} value={currentNode}>
          当前审批节点
        </InputItem>
      </List>
      <Accordion defaultActiveKey="0" className="my-accordion">
        {masterData && (
          <Accordion.Panel
            header={
              masterData.是否内训订单 === "fef2a687f35c2936843e5ed03dfbc584"
                ? "产品订单"
                : "内训订单"
            }>
            <List className="picker-list">
              <Picker
                data={orderType}
                cols={1}
                disabled={true}
                value={[masterData.订单类型]}>
                <List.Item arrow="horizontal">订单类型</List.Item>
              </Picker>
              <Picker
                data={customerName}
                cols={1}
                value={[masterData.customerId]}
                disabled={true}>
                <List.Item arrow="horizontal">客户名称</List.Item>
              </Picker>
              <Picker
                data={customerCategory}
                cols={1}
                value={[masterData.客户类型]}
                disabled>
                <List.Item arrow="horizontal">客户类型</List.Item>
              </Picker>
              <InputItem editable={false} value={contactName}>
                联系人
              </InputItem>
            </List>
          </Accordion.Panel>
        )}
        {masterData &&
        masterData.是否内训订单 === "fef2a687f35c2936843e5ed03dfbc584" ? (
          <Accordion.Panel header="产品信息">
            {productInfo.length > 0 &&
              productNames.length > 0 &&
              productInfo.map((item, index) => (
                <div key={"item" + index}>
                  <div className="titleDiv">
                    产品{index + 1}-{productNames[index]}
                  </div>
                  {item.data && (
                    <List className="picker-list">
                      {productOptions.length > 0 && (
                        <Picker
                          data={productOptions}
                          cols={3}
                          value={[
                            item.data.产品归属,
                            item.data.产品分类,
                            item.data.产品名称,
                          ]}
                          disabled>
                          <List.Item arrow="horizontal">产品名称</List.Item>
                        </Picker>
                      )}

                      <InputItem
                        placeholder="0"
                        extra="元"
                        editable={false}
                        value={item.data.单价}>
                        产品原价
                      </InputItem>
                      <InputItem value={item.data.课程名称} editable={false}>
                        课程名称
                      </InputItem>
                      <InputItem
                        placeholder="0"
                        extra="元"
                        editable={false}
                        value={item.data.销售指导价}>
                        销售指导价
                      </InputItem>
                      <InputItem editable={false} value={item.data.数量}>
                        数量
                      </InputItem>
                      {giftOptions.length > 0 && (
                        <Picker
                          data={giftOptions}
                          cols={2}
                          value={[item.data.赠品类型, item.data.赠品]}
                          disabled>
                          <List.Item arrow="horizontal">赠品名称</List.Item>
                        </Picker>
                      )}
                      <InputItem
                        placeholder="0"
                        extra="元"
                        editable={false}
                        value={item.data.赠品采购价}>
                        赠品采购价
                      </InputItem>
                      <InputItem
                        placeholder="0"
                        extra="元"
                        editable={false}
                        value={item.data.赠品含税成本价}>
                        赠品含税成本价
                      </InputItem>
                      <InputItem
                        placeholder="0"
                        extra="元"
                        editable={false}
                        value={item.data.赠品内部核算价}>
                        赠品内部核算价
                      </InputItem>
                      <InputItem
                        placeholder="0"
                        extra="元"
                        editable={false}
                        value={item.data.应收小计}>
                        应收小计
                      </InputItem>
                      <InputItem editable={false} value={item.data.销售折扣}>
                        销售折扣
                      </InputItem>
                      <InputItem
                        placeholder="0"
                        extra="元"
                        editable={false}
                        value={item.data.实收款}>
                        <span className="redSpan">实收款</span>
                      </InputItem>
                      <InputItem
                        placeholder="0"
                        extra="元"
                        editable={false}
                        value={item.data.远见收入}>
                        收入
                      </InputItem>
                      <InputItem editable={false} value={item.data.业绩系数}>
                        业绩系数
                      </InputItem>
                      <InputItem
                        placeholder="0"
                        extra="元"
                        editable={false}
                        value={item.data.销售业绩额}>
                        销售业绩额
                      </InputItem>
                    </List>
                  )}
                </div>
              ))}
          </Accordion.Panel>
        ) : (
          <Accordion.Panel header="产品信息">
            {trainingproductInfo &&
              trainingproductInfo.map((item, index) => (
                <div key={"trainingProduct" + index}>
                  {item.data && (
                    <List className="picker-list">
                      {productDictionary.length > 0 && (
                        <Picker
                          data={productDictionary}
                          cols={1}
                          value={[item.data.内训_产品名称]}
                          disabled>
                          <List.Item arrow="horizontal">产品名称</List.Item>
                        </Picker>
                      )}
                      <InputItem
                        placeholder="0"
                        extra="元"
                        editable={false}
                        value={item.data.内训_单价}>
                        合同金额
                      </InputItem>

                      <InputItem editable={false} value={masterData.签约单位}>
                        签约单位
                      </InputItem>
                    </List>
                  )}
                </div>
              ))}
          </Accordion.Panel>
        )}
        {masterData &&
          masterData.是否内训订单 !== "fef2a687f35c2936843e5ed03dfbc584" && (
            <Accordion.Panel header="预算明细">
              {costDetail.length > 0 &&
                costDescriptions.length > 0 &&
                costDetail.map((item) => (
                  <InputItem
                    placeholder="0"
                    extra="元"
                    editable={false}
                    value={item.data.预算金额}>
                    {costDescriptions.some(
                      (option) => option.uuid === item.data.预算类别
                    )
                      ? costDescriptions.find(
                          (option) => option.uuid === item.data.预算类别
                        )?.name
                      : ""}
                  </InputItem>
                ))}
            </Accordion.Panel>
          )}

        {masterData &&
          masterData.是否内训订单 === "fef2a687f35c2936843e5ed03dfbc584" &&
          memberCardDetail.length > 0 &&
          productNames.length > 0 && (
            <Accordion.Panel header="会员信息">
              {memberCardDetail.map((item, index) => (
                <div key={"code" + index}>
                  <div className="titleDiv">
                    产品{index + 1}-{productNames[index]}
                  </div>
                  <InputItem
                    editable={false}
                    value={item.data.会员卡明细_会员卡号}>
                    会员卡号
                  </InputItem>
                </div>
              ))}
            </Accordion.Panel>
          )}
        {masterData &&
          masterData.是否内训订单 === "fef2a687f35c2936843e5ed03dfbc584" &&
          serviceDetail.length > 0 && (
            <Accordion.Panel header="服务明细">
              {serviceDetail.map((item, index) => (
                <div key={"service" + index}>
                  {/* <div className="titleDiv">
                  产品{index + 1}-{productNames[index]}
                </div> */}
                  {serviceDictionary.length > 0 && (
                    <InputItem
                      editable={false}
                      value={item.data.产品服务明细_数量}
                      extra={item.data.产品服务明细_规格}>
                      {serviceDictionary.some(
                        (option) =>
                          option.value === item.data.产品服务明细_服务名称
                      )
                        ? serviceDictionary.find(
                            (option) =>
                              option.value === item.data.产品服务明细_服务名称
                          )?.label
                        : ""}
                    </InputItem>
                  )}
                </div>
              ))}
            </Accordion.Panel>
          )}
        {masterData && (
          <Accordion.Panel header="费用计算">
            <List className="picker-list">
              <InputItem
                placeholder="0"
                extra="元"
                editable={false}
                value={masterData.订单总额}>
                订单总额
              </InputItem>
              {masterData.是否内训订单 ===
                "fef2a687f35c2936843e5ed03dfbc584" && (
                <InputItem editable={false} value={masterData.正保币}>
                  正保币
                </InputItem>
              )}
              {masterData.是否内训订单 ===
                "fef2a687f35c2936843e5ed03dfbc584" && (
                <InputItem editable={false} value={masterData.学习卡}>
                  学习卡
                </InputItem>
              )}
              <InputItem
                placeholder="0"
                extra="元"
                editable={false}
                value={masterData.应收总额}>
                实收总额
              </InputItem>
              <InputItem
                placeholder="0.00"
                extra="元"
                editable={false}
                value={masterData.销售业绩总额}>
                销售业绩总额
              </InputItem>
              {payDictionary.length > 0 && (
                <Picker
                  data={payDictionary}
                  cols={1}
                  disabled
                  value={[masterData.支付方式]}>
                  <List.Item arrow="horizontal">支付方式</List.Item>
                </Picker>
              )}
              <DatePicker
                mode="date"
                disabled={true}
                value={
                  masterData.预计到款日期
                    ? new Date(
                        new Date(
                          masterData.预计到款日期.replace(/-/g, "/")
                        ).getTime()
                      )
                    : undefined
                }>
                <List.Item arrow="horizontal">预计到款日期</List.Item>
              </DatePicker>
              {companyDictionary.length > 0 && (
                <Picker
                  data={companyDictionary}
                  cols={1}
                  disabled
                  value={[masterData.到款单位]}>
                  <List.Item arrow="horizontal">收款单位</List.Item>
                </Picker>
              )}
              <InputItem
                editable={false}
                placeholder="请输入"
                value={masterData.汇款单位}>
                汇款单位
              </InputItem>
              <TextareaItem
                title="备注"
                autoHeight
                labelNumber={2}
                value={masterData.备注 || ""}
                editable={false}
              />
            </List>
          </Accordion.Panel>
        )}
        <Accordion.Panel header="到款方式">
          {collectionTypeDetail.length > 0 &&
          collectionTypeDetail[0].data.uuid !== "0" ? (
            <div>
              <List className="my-list">
                <InputItem value={"分批到款"} editable={false}>
                  到款方式
                </InputItem>
                {collectionTypeDetail.map((item, index) => (
                  <div key={"collection" + index}>
                    <div className="titleDiv">批次{index + 1}</div>
                    <DatePicker
                      mode="date"
                      value={
                        item.data.到款方式明细_预计到款时间
                          ? new Date(
                              new Date(
                                item.data.到款方式明细_预计到款时间.replace(
                                  /-/g,
                                  "/"
                                )
                              ).getTime()
                            )
                          : undefined
                      }
                      disabled={true}>
                      <List.Item arrow="horizontal">预计到款日期</List.Item>
                    </DatePicker>
                    <InputItem
                      value={item.data.到款方式明细_汇款单位}
                      editable={false}>
                      汇款单位
                    </InputItem>
                    <InputItem
                      value={item.data.到款方式明细_还款金额}
                      extra={"元"}
                      editable={false}>
                      还款金额
                    </InputItem>
                  </div>
                ))}
              </List>
            </div>
          ) : (
            <List className="my-list">
              <InputItem value={"全部到款"} editable={false}>
                到款方式
              </InputItem>
            </List>
          )}
        </Accordion.Panel>
        <Accordion.Panel header="订单拆分">
          {orderSplitDetail.length > 0 &&
          orderSplitDetail[0].data.uuid !== "0" ? (
            <>
              <List className="my-list">
                <InputItem value={"拆分"} editable={false}>
                  是否拆分
                </InputItem>
                <div className="titleDiv">营销地业务员</div>
                {orderSplitSaleDetail.length > 0 &&
                  orderSplitSaleDetail.map((item, index) => (
                    <div key={"splitSale" + index}>
                      {staffDictionary.length > 0 && (
                        <Picker
                          data={staffDictionary}
                          cols={1}
                          disabled
                          value={[item.销售地业务员]}>
                          <List.Item arrow="horizontal">业务员</List.Item>
                        </Picker>
                      )}
                      <InputItem value={item.比例} extra={"%"} editable={false}>
                        比例
                      </InputItem>
                    </div>
                  ))}
                <div className="titleDiv">服务地业务员</div>
                {orderSplitServiceDetail.length > 0 &&
                  orderSplitServiceDetail.map((item, index) => (
                    <div key={"splitService" + index}>
                      {staffDictionary.length > 0 && (
                        <Picker
                          data={staffDictionary}
                          cols={1}
                          disabled
                          value={[item.服务地业务员]}>
                          <List.Item arrow="horizontal">业务员</List.Item>
                        </Picker>
                      )}
                      <InputItem value={item.比例} extra={"%"} editable={false}>
                        比例
                      </InputItem>
                    </div>
                  ))}
              </List>
            </>
          ) : (
            <List className="my-list">
              <InputItem value={"不拆分"} editable={false}>
                是否拆分
              </InputItem>
            </List>
          )}
        </Accordion.Panel>
      </Accordion>
    </div>
  );
}
